import script from "./LearningItemForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./LearningItemForm.vue?vue&type=script&lang=ts&setup=true"

import "./LearningItemForm.vue?vue&type=style&index=0&id=077ebeb1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-077ebeb1"]])

export default __exports__